import React, { useState } from 'react';
import { connect } from 'redux-zero/react';
import { useTranslation } from 'react-i18next';
import { formActions } from 'app/state/actions';
import { DsTabs, DsTooltip, DsTab, DsIcon } from '@tokenyico/design-system/dist/reactJS';

import DvDTransferToken from './DvDTransferToken';
import DirectTransferToken from './DirectTransferToken';

const TransferToken = (props) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState(0);

  const isDvdDisabled = props.token.conditionalTransfersEnabled;

  return (
    <div className="_p:x(2)" style={{ maxWidth: '36rem' }}>
      <DsTabs
        isFullWidth={true}
        version="background"
        onTabChange={({ detail }) => setCurrentTab(detail)}
        currentTab={currentTab}
        className="_m:bottom(4) _m:top(3)"
      >
        <DsTab padding="0.8rem 1.6rem">
          <DsIcon name="arrow-right" size="16px" className="_m:right(2)" />
          <span>{t('shared.directTransfer')}</span>
        </DsTab>

        <DsTooltip
          text={t('shared.dvdNotEnabled')}
          position="top"
          size="xs"
          isVisibleOnHover={isDvdDisabled}
          style={{ minWidth: '50%' }}
          className="_flex"
        >
          <DsTab padding="0.8rem 1.6rem" isDisabled={isDvdDisabled}>
            <DsIcon name="transfer" size="16px" className="_m:right(2)" />
            <span>{t('shared.dvdTransfer')}</span>
          </DsTab>
        </DsTooltip>
      </DsTabs>

      {currentTab === 0 && <DirectTransferToken {...props} />}
      {currentTab === 1 && <DvDTransferToken {...props} />}
    </div>
  );
};

const mapToProps = (state) => state;
export default connect(mapToProps, formActions)(TransferToken);
